/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";

/** @module core/modules/object-utils/stringify-circular */
import { forEachSync } from './for-each-sync.js';
/** @typedef {(Object<string,*>|Array<*>)} stringifyCircularInputType */

/**
 * @description Stringifies input circular references.
 * @param {stringifyCircularInputType} obj - Input object.
 * @returns {stringifyCircularInputType} Resulting object.
 */

function stringifyCircular(obj) {
  var _this = this,
      _context;

  forEachSync(obj, _bindInstanceProperty(_context = function _context() {
    _newArrowCheck(this, _this);
  }).call(_context, this), {
    circularCheck: true,
    onCircular: function onCircular(val, refPath, API) {
      API.replaceValue("[CIRCULAR:".concat(refPath, "]"));
    }
  });
  return obj;
}

export { stringifyCircular };